import { TextField, Upload } from '@tmov/design-system';
import { Col, DatePicker, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { removeCaracteresEspeciais } from '../../../../../../../../helpers/formatador';
import { ModalInfo, ModalTitle } from '../styles';

const TagEmbarcadoForm = ({
  tagDataCarregamento,
  setTagDataCarregamento,
  setTagPeso,
  setTagDocumentos,
  anexoNfe,
  isTransportadoraExterna,
}) => {
  const [localValue, setLocalValue] = useState('');
  const [fileSelect, setFileSelect] = useState([]);

  const localFormat = value => {
    if (!value) return '';
    if (value.length <= 2) return value;
    const inicio = value.slice(0, value.length - 2);
    const final = value.slice(value.length - 2, value.length);
    return `${inicio},${final}`;
  };

  const handlePesoInput = event => {
    const { value } = event.target;
    if (value.length > 5) return;
    const valueSemVirgula = removeCaracteresEspeciais(value);
    const variavel = localFormat(valueSemVirgula);
    setLocalValue(variavel);
    setTagPeso(parseFloat(variavel.replace(',', '.')));
  };

  const validaFormatoArquivo = arquivo =>
    arquivo &&
    (arquivo.type === 'application/pdf' ||
      arquivo.type === 'image/jpeg' ||
      arquivo.type === 'image/png');

  const handleFileUpload = (arquivo, index) => {
    if (validaFormatoArquivo(arquivo)) {
      setFileSelect([...fileSelect, { arquivo, index }]);
      setTagDocumentos([...fileSelect, { arquivo, index }]);
    } else {
      setFileSelect([...fileSelect.filter(file => file.index !== index)]);
      setTagDocumentos([...fileSelect.filter(file => file.index !== index)]);
    }
  };

  return (
    <>
      <Col>
        <ModalTitle>Embarcar motorista</ModalTitle>

        {anexoNfe && (
          <>
            <ModalInfo>NF-e</ModalInfo>
            <ModalInfo regular>
              Adicione até duas notas fiscais eletrônicas para atualizar o
              status do motorista.
            </ModalInfo>
          </>
        )}

        {!anexoNfe && (
          <ModalInfo regular>
            Por favor, inclua o peso carregado e data para atualizar o status da
            viagem.
          </ModalInfo>
        )}

        {isTransportadoraExterna && (
          <ModalInfo regular>
            Peso carregado (min. 10 ton / máx. 55 ton)
          </ModalInfo>
        )}
      </Col>

      {anexoNfe && (
        <>
          <Col style={{ marginBottom: '20px' }}>
            <Row>
              <Upload
                file={
                  fileSelect.find(f => f.index === 0) &&
                  fileSelect.find(f => f.index === 0).arquivo
                }
                onChange={e => handleFileUpload(e, 0)}
              />
            </Row>
            {Object.keys(fileSelect).length > 0 && (
              <Row>
                <Upload
                  file={
                    fileSelect.find(f => f.index === 1) &&
                    fileSelect.find(f => f.index === 1).arquivo
                  }
                  onChange={e => handleFileUpload(e, 1)}
                />
              </Row>
            )}
          </Col>
        </>
      )}

      {isTransportadoraExterna && (
        <Row>
          <TextField
            value={localValue}
            label="Peso"
            required={true}
            size="sm"
            onChange={event => handlePesoInput(event)}
            style={{ width: '184px' }}
          />

          <Col style={{ marginLeft: '32px' }}>
            <DatePicker
              defaultValue={tagDataCarregamento}
              name="dataCarregamento"
              format="DD/MM/YYYY"
              style={{ width: '184px', height: '36px', borderRadius: '4px' }}
              onChange={event => setTagDataCarregamento(event)}
            />
          </Col>
        </Row>
      )}
    </>
  );
};

TagEmbarcadoForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tagDataCarregamento: PropTypes.object.isRequired,
  setTagDataCarregamento: PropTypes.func.isRequired,
  setTagPeso: PropTypes.func.isRequired,
  setTagDocumentos: PropTypes.func.isRequired,
  anexoNfe: PropTypes.bool,
  isTransportadoraExterna: PropTypes.bool.isRequired,
};

TagEmbarcadoForm.defaultProps = {
  anexoNfe: false,
};

export default TagEmbarcadoForm;
